<template>
  <b-sidebar
    id="sidebar-1"
    title="Sidebar"
    shadow
    visible
    no-header
    no-close-on-esc
    no-close-on-backdrop
    no-close-on-route-change
    width="15%"
    class="side-menu"
  >
    <b-row align-v="center" class="row sidemenu-icon text-center">
      <b-col class="pl-5 pr-5 pt-2 pb-2">
        <div>
          <b-avatar
            size="100px"
            v-if="user.PhotoPath"
            variant="info"
            :src="`data:image/jpg;base64,${user.PhotoPath}`"
          ></b-avatar>
          <b-avatar
            v-else
            size="100px"
            :text="userAlias"
            variant="info"
          ></b-avatar>
        </div>
        <div class="text-white">
          <b>{{ userName }}</b>
        </div>
        <div class="text-white">
          <b>{{ user.JobTitle }}</b>
        </div>
      </b-col>
    </b-row>
    <b-row class="slider-content">
      <b-col cols="12">
        <div v-for="(menu, menuIndex) in menuList" :key="menuIndex">
          <button
            v-b-toggle="menu.childrenID"
            type="button"
            :class="{
              btn: true,
              sidemenu: true,
              'sidemenu-selected': currentRoutePath === menu.path
            }"
            @click="routeTo(menu.path)"
            v-if="hasRight('AlwRead', menu.menuID) && menu.show"
          >
            <b-row>
              <b-col class="p-0" sm="3">
                <img :src="menu.img" class="imgIcon mr-2" />
              </b-col>
              <b-col class="p-0 text-left" sm="9">
                <b-row
                  class="no-gutters justify-content-between align-items-center"
                >
                  <span>{{ menu.text }}</span>
                  <font-awesome-icon
                    v-if="menu.children.length > 0"
                    class="float-right mr-2"
                    icon="plus"
                  />
                </b-row>
              </b-col>
            </b-row>
          </button>
          <b-collapse
            :id="menu.childrenID"
            class="mt-2"
            v-for="(childMenu, childIndex) in menu.children"
            :key="childIndex"
          >
            <button
              type="button"
              :class="{
                btn: true,
                sidemenu: true,
                'sidemenu-selected': currentRoutePath === childMenu.path
              }"
              @click="routeTo(childMenu.path)"
              v-if="hasRight('AlwRead', childMenu.menuID) && childMenu.show"
            >
              <b-row>
                <b-col cols="3"></b-col>
                <b-col class="p-0 text-left" sm="9">
                  <span>{{ childMenu.text }}</span>
                </b-col>
              </b-row>
            </button>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
  </b-sidebar>
</template>

<script>
import MenuRightService from "@/service/MenuRightService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import $t from "@/service/SysMsgService";
import Settings from "../../constants/Settings";
import { click } from "@syncfusion/ej2-grids";

export default {
  props: ["menuRights"],
  data() {
    return {
      dictEnum: dictEnum,
      Settings: Settings,
      menuList: []
    };
  },
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    t() {
      return $t;
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName +
            " " +
            this.$store.getters[StoreGetter.user].EngLastName
        : this.$store.getters[StoreGetter.user].ChiLastName +
            this.$store.getters[StoreGetter.user].ChiName;
    },
    currentRoutePath() {
      return this.$route.path;
    },
    userAlias() {
      let alias = "";
      if (this.user.Lang == "EN") {
        alias = this.user.EngName.charAt(0) + this.user.EngLastName.charAt(0);
      } else {
        alias = this.user.ChiLastName
          ? this.user.ChiLastName
          : this.user.ChiName.charAt(0);
      }
      return alias;
    }
  },
  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.$props.menuRights.allRights).length === 0) {
        return false;
      } else {
        if (!menuId) return true;
        return MenuRightService.hasRightInMenu(
          this.$props.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    routeTo(routeName) {
      if (routeName) {
        this.$router.push(routeName);
      }
    },
//获取菜单列表
    getMenus() {
      // SysParams
      // 从 Vuex store 中获取系统参数
      const sysParams = this.$store.getters[StoreGetter.sysParams];
      console.log(sysParams,8888);
      // 初始化模块开关变量，默认值为 true
      let modClk = true,
        modLv = true,
        modRecu = true,
        modPay = true;
        // 查找各个模块的开关设置，根据系统参数动态调整模块启用状态
      const clkFind = sysParams.find(
        x => x.ParamCode == Settings.SysParams.ModCLK
      );
      if (clkFind) {
        modClk = clkFind.ParamVal.toLowerCase() === "true";
      }
      const lvFind = sysParams.find(
        x => x.ParamCode == Settings.SysParams.ModLv
      );
      if (lvFind) {
        modLv = lvFind.ParamVal.toLowerCase() === "true";
      }
      const RecuFind = sysParams.find(
        x => x.ParamCode == Settings.SysParams.ModRecu
      );
      if (RecuFind) {
        modRecu = RecuFind.ParamVal.toLowerCase() === "true";
      }
      const PayFind = sysParams.find(
        x => x.ParamCode == Settings.SysParams.ModPay
      );
      if (PayFind) {
        modPay = PayFind.ParamVal.toLowerCase() === "true";
      }
        // 定义菜单数据结构
      let data = [
         // 菜单项定义，包括菜单ID、图标、路径、文本、子菜单及显示状态
         // 以下为示例菜单项，实际菜单项应根据系统参数动态调整
        {
          menuID: "",
          img: "../../../static/images/calendar.png",
          path: "/Calendar",
          text: $t.t(dictEnum.LBL_Calendar),
          childrenID: "",
          children: [],
          show: modLv
        },
        {
          menuID: Settings.MenuID.Approval,
          img: "../../../static/images/menuIcon/iconApproval.png",
          path: "/approval",
          text: $t.t(dictEnum.MENU_Approval),
          childrenID: "",
          children: [],
          show: modLv
        },
        {
          menuID: Settings.MenuID.Employees,
          img: "../../../static/images/menuIcon/iconApproval.png",
          path: "/employees",
          text: $t.t(dictEnum.MENU_Employees),
          childrenID: "",
          children: [],
          show: true
        },
        {
          menuID: Settings.MenuID.Payroll,
          img: "../../../static/images/iconCandidate.png",
          path: "",
          text: $t.t(dictEnum.LBL_Payroll),
          childrenID: "collapse-payroll",
          children: [
            {
              menuID: Settings.MenuID.PayProfile,
              img: "",
              path: "/payProfile",
              text: $t.t(dictEnum.LBL_PayProfile),
              show: modPay
            },
            {
              menuID: Settings.MenuID.PayrollTrial,
              img: "",
              path: "/payrollTrial",
              text: $t.t(dictEnum.LBL_PayrollTrial),
              show: modPay
            },
            {
              menuID: Settings.MenuID.SpecialPayment,
              img: "",
              path: "/specialPayment",
              text: $t.t(dictEnum.LBL_SpecialPayment),
              show: modPay
            },
            {
              menuID: Settings.MenuID.PayrollAdjustment,
              img: "",
              path: "/payrollAdjustment",
              text: $t.t(dictEnum.LBL_PayrollAdjustment),
              show: modPay
            },
            {
              menuID: Settings.MenuID.PayrollApproval,
              img: "",
              path: "/payrollApproval",
              text: $t.t(dictEnum.LBL_Approval),
              show: modPay
            },
            {
              menuID: Settings.MenuID.FinalPayment,
              img: "",
              path: "/finalPayment",
              text: $t.t(dictEnum.LBL_FinalPayment),
              show: modPay
            }
          ],
          show: modPay
        },
        {
          menuID: Settings.MenuID.Candidate,
          img: "../../../static/images/iconCandidate.png",
          path: "",
          text: $t.t(dictEnum.LBL_Candidate),
          childrenID: "collapse-candidate",
          children: [
            {
              menuID: Settings.MenuID.Job,
              img: "",
              path: "/job",
              text: $t.t(dictEnum.LBL_JobAds),
              show: modRecu
            },
            {
              menuID: Settings.MenuID.NewCandidate,
              img: "",
              path: "/InviteNewCandidate",
              text: $t.t(dictEnum.LBL_InviteCandidate),
              show: modRecu
            },
            {
              menuID: Settings.MenuID.JobApplicationForm,
              img: "",
              path: "/JobApplicationForm",
              text: $t.t(dictEnum.LBL_JobApplicationForm),
              show: modRecu
            },
            {
              menuID: Settings.MenuID.Enquiry,
              img: "",
              path: "/Enquiry",
              text: $t.t(dictEnum.LBL_Enquiry),
              show: modRecu
            }
          ],
          show: modRecu
        },
        {
          menuID: Settings.MenuID.OutdoorWork,
          img: "../../../static/images/menuIcon/iconOutdoorwork.png",
          path: "/outdoorwork",
          text: $t.t(dictEnum.MENU_OutdoorWork),
          childrenID: "",
          children: [],
          show: modClk
        },
        {
          menuID: Settings.MenuID.LeaveApplication,
          img: "../../../static/images/menuIcon/icooLeaveApp.png",
          path: "/leaveapplication",
          text: $t.t(dictEnum.MENU_LeaveApp),
          childrenID: "",
          children: [],
          show: modLv
        },
        {
          menuID: Settings.MenuID.Report,
          img: "../../../static/images/menuIcon/iconReport.png",
          path: "",
          text: $t.t(dictEnum.MENU_Report),
          childrenID: "collapse-report",
          children: [
            {
              menuID: Settings.MenuID.StaffLeaveRecord,
              img: "",
              path: "/staffLeaveRecord",
              text: $t.t(dictEnum.MENU_StaffLeaveRecord),
              show: modLv
            },
            {
              menuID: Settings.MenuID.StaffAttendance,
              img: "",
              path: "/staffAttendance",
              text: $t.t(dictEnum.MENU_StaffAttendance),
              show: modClk
            },
            {
              menuID: Settings.MenuID.MonthlyLeaveBalance,
              img: "",
              path: "/monthlyLeaveBalance",
              text: $t.t(dictEnum.MENU_MonthlyLeaveBalance),
              show: modLv
            },
            {
              menuID: Settings.MenuID.OutdoorWorkAllowance,
              img: "",
              path: "/outdoorWorkAllowance",
              text: $t.t(dictEnum.MENU_OutdoorWorkAllowance),
              show: modClk
            },
            {
              menuID: Settings.MenuID.TaxReturn,
              img: "",
              path: "/taxReturn",
              text: $t.t(dictEnum.MENU_TaxReturn),
              show: modClk
            }
          ],
          show: modClk || modLv
        },
        {
          menuID: Settings.MenuID.MM,
          img: "../../../static/images/menuIcon/iconMM.png",
          path: "",
          text: $t.t(dictEnum.MENU_MasterMaintenance),
          childrenID: "collapse-mm",
          children: [
            {
              menuID: Settings.MenuID.MM_LeaveType,
              img: "",
              path: "/leaveType",
              text: $t.t(dictEnum.MENU_LeaveType),
              show: modLv
            },
            {
              menuID: Settings.MenuID.MM_StaffGrading,
              img: "",
              path: "/staffGrading",
              text: $t.t(dictEnum.MENU_StaffGrading),
              show: modLv || modRecu
            },
            {
              menuID: Settings.MenuID.MM_AnnualLeavePlan,
              img: "",
              path: "/annualLeavePlan",
              text: $t.t(dictEnum.MENU_AnnualLeavePlan),
              show: modLv
            },
            {
              menuID: Settings.MenuID.MM_WorkType,
              img: "",
              path: "/workType",
              text: $t.t(dictEnum.MENU_WorkType),
              show: modClk
            },
            {
              menuID: Settings.MenuID.MM_Holiday,
              img: "",
              path: "/holiday",
              text: $t.t(dictEnum.MENU_Holiday),
              show: modClk || modLv
            },
            {
              menuID: Settings.MenuID.MM_ShiftType,
              img: "",
              path: "/shiftType",
              text: $t.t(dictEnum.MENU_ShiftType),
              show: modClk
            },
            {
              menuID: Settings.MenuID.MM_Roster,
              img: "",
              path: "/roster",
              text: $t.t(dictEnum.MENU_Roster),
              show: modClk
            },
            {
              menuID: Settings.MenuID.MM_Loc,
              img: "",
              path: "/location",
              text: $t.t(dictEnum.MENU_Location),
              show: modClk
            },
            {
              menuID: Settings.MenuID.MM_RosterPlan,
              img: "",
              path: "/rosterPlan",
              text: $t.t(dictEnum.MENU_RosterPlan),
              show: modClk
            }
          ],
          show: true
        },
        {
          menuID: Settings.MenuID.Administration,
          img: "../../../static/images/menuIcon/iconAdmin.png",
          path: "",
          text: $t.t(dictEnum.MENU_Administration),
          childrenID: "collapse-admin",
          children: [
            {
              menuID: Settings.MenuID.UserList,
              img: "",
              path: "/userList",
              text: $t.t(dictEnum.MENU_UserList),
              show: true
            },
            {
              menuID: Settings.MenuID.UserGroups,
              img: "",
              path: "/usergroup",
              text: $t.t(dictEnum.MENU_UserGrp),
              show: true
            },
            {
              menuID: Settings.MenuID.UserGroupsRights,
              img: "",
              path: "/usergrouprights",
              text: $t.t(dictEnum.MENU_UserGrpRights),
              show: true
            },
            {
              menuID: Settings.MenuID.SyncUsertoMizar,
              img: "",
              path: "/syncUserToMizar",
              text: $t.t(dictEnum.MENU_SyncUsertoMizar),
              show: true
            }
          ],
          show: true
        },
        {
          menuID: Settings.MenuID.Setup,
          img: "../../../static/images/iconsetup.png",
          path: "/setup",
          text: $t.t(dictEnum.MENU_Setup),
          childrenID: "",
          children: [],
          show: true
        }
      ];
       // 将生成的菜单列表赋值给组件的menuList属性
      this.menuList = data;
    }
  },

  mounted() {
    this.getMenus();
    console.log(this);
  }
};
</script>
<style scoped scss>
.slider-content {
  height: 70% !important;
  overflow: auto;
}
.sidemenu-icon {
  min-height: 150px;
  max-height: 150px;
}
.imgIcon {
  height: 20px;
}

.sidemenu {
  color: white;
  width: 100%;
}

>>> .b-sidebar {
  top: 75px;
  height: 100vh !important;
}

.sidemenu-selected {
  color: #ffffff !important;
  background-image: linear-gradient(90deg, #05cd7e 0%, #2ab5cf 100%);
}
.sidemenu.sidemenu-selected {
  background: #18203c;
  color: #2ab5cf !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/SideMenuComponent.vue